import React from "react";
import { PanelAddCategory } from "../../../UI/Categories/Add/PanelAddCategory";
import {PanelAddEmailTemplate} from "../../../UI/EmailTemplates/Add/PanelAddEmailTemplate";

const AddEmailTemplate = () => {
  return (
    <div>
      <PanelAddEmailTemplate />
    </div>
  );
};

export default AddEmailTemplate;
